import { initFirebase, startContactTrace, trackContactResult } from "./firebase.js";

document.addEventListener("DOMContentLoaded", function () {
  initFirebase();

  const form = document.getElementById("contact-form");
  if (!form) return; // safety guard

  const nameInput = document.getElementById("name");
  const emailInput = document.getElementById("email");
  const eventTypeInput = document.getElementById("event-type");
  const eventDateInput = document.getElementById("event-date");
  const phoneInput = document.getElementById("phone");
  const messageInput = document.getElementById("message");
  const resultEl = document.getElementById("contact-result");
  const csrfInput = document.getElementById("csrf_token");

  if (eventDateInput) {
    const today = new Date().toISOString().split("T")[0];
    eventDateInput.setAttribute("min", today);
  }

  // Generate a short-lived CSRF token and store in cookie + hidden field
  function createCsrfToken() {
    if (!csrfInput || !window.crypto || !window.crypto.getRandomValues) return;

    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);
    const token = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

    const cookieParts = [
      `nrg_csrf=${token}`,
      "Path=/",
      "Max-Age=7200", // 2 hours
      "SameSite=Lax"
    ];

    if (location.protocol === "https:") {
      cookieParts.push("Secure");
    }

    document.cookie = cookieParts.join("; ");
    csrfInput.value = token;
  }

  createCsrfToken();

  function showMessage(msg, isError) {
    alert(msg);

    if (resultEl) {
      resultEl.textContent = msg;
      resultEl.className = "contact-form__result";
      if (isError) {
        resultEl.classList.add("contact-form__result--error");
      } else {
        resultEl.classList.add("contact-form__result--success");
      }
    }
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const message = messageInput.value.trim();
    const phone = phoneInput.value.trim();
    const eventDate = eventDateInput.value;

    const errors = [];

    if (!name) {
      errors.push("Name is required.");
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailPattern.test(email)) {
      errors.push("Please enter a valid email address.");
    }

    // Egyptian mobile validation (same logic as PHP)
    if (!phone) {
      errors.push("Mobile number is required.");
    } else {
      const digits = phone.replace(/\D+/g, "");

      const validLocal = /^01[0-2,5][0-9]{8}$/.test(digits); // 010 / 011 / 012 / 015 + 8 digits
      const validIntl = /^201[0-2,5][0-9]{8}$/.test(digits); // 2010 / 2011 / 2012 / 2015 + 8 digits

      if (!validLocal && !validIntl) {
        errors.push("Please enter a valid Egyptian mobile number.");
      }
    }

    if (!message || message.length < 5) {
      errors.push("Message is too short.");
    }

    if (eventDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selected = new Date(eventDate);
      selected.setHours(0, 0, 0, 0);
      if (selected < today) {
        errors.push("Please choose an event date today or in the future.");
      }
    }

    if (errors.length > 0) {
      showMessage(errors.join(" "), true);
      return;
    }

    const formData = new FormData(form);
    const contactTrace = startContactTrace();

    try {
      const response = await fetch("contact.php", {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      });

      const data = await response.json();

      if (data.ok) {
        showMessage(data.message || "Thank you, your message was sent.", false);
        form.reset();
        trackContactResult("success");

        // Re-apply min date after reset
        if (eventDateInput) {
          const today = new Date().toISOString().split("T")[0];
          eventDateInput.setAttribute("min", today);
        }

        // Rotate CSRF token after a successful submission
        createCsrfToken();
      } else {
        const errorMessage = data.error || "Sorry, something went wrong.";
        showMessage(errorMessage, true);
        trackContactResult("error", errorMessage);
      }
    } catch (err) {
      showMessage("Network error. Please try again later.", true);
      trackContactResult("error", "network_error");
    } finally {
      if (contactTrace && typeof contactTrace.stop === "function") {
        contactTrace.stop();
      }
    }
  });
});
